import React, { useContext } from 'react';
import { EditGroupViewContext } from '../../EditableGroupedView/context/EditGroupViewContextProvider';

const useMarkEditedLogicAccordion = (titleId) => {
  const GroupViewContextConstants = useContext(
    EditGroupViewContext
  );

  const ZeroFilteredEditGroupViewConstants =
    GroupViewContextConstants?.MedicalDefaultValues?.map(
      (element) => ({
        ...element,
        value:
          Number(element.value) === 0 ? '' : element.value,
      })
    );

  const matchForms =
    ZeroFilteredEditGroupViewConstants?.filter(
      (element) =>
        element?.value?.toString()?.length > 0 &&
        element?.element?.IdGroupDetail === titleId
    );
  const isFormEdited = matchForms?.map((frm) => {
    if (
      frm?.UiValue?.Value?.toString() !==
      frm?.value?.toString()
    ) {
      return {
        ...frm,
        isEdit: false,
      };
    } else {
      return {
        ...frm,
      };
    }
  });
  return isFormEdited;
};

export default useMarkEditedLogicAccordion;
